import './css/Cover_flow.css'

const Cover_flow = () => {
    return(
        <div className='cover_flow-page'>
            <h2>Cover flow</h2>
        </div>
    )
}

export default Cover_flow;